export const DEFAULT_SVG_COLOR = '#ffffff';
export const DEFAULT_SVG_STROKE_WIDTH = '2';

export const SVG_RADIUS = 40;
export const SVG_LINE_SIZE = 6;

export const SVG_ARROW_POINTS = '0,0,5,5,-5,5';
export const INITIAL_MATRIX_POINTS = '1,0,0,1';
